import { IComponentOptions } from 'angular';
import { LoadingSpinnerController } from 'src/modules/loading/LoadingSpinnerController';
import * as LoadingSpinnerTemplate from './LoadingSpinnerTemplate.html';

export const LOADING_SPINNER_COMPONENT: IComponentOptions = {
    template: LoadingSpinnerTemplate,
    controller: LoadingSpinnerController,
};
